import { render, staticRenderFns } from "./FtpRequests.vue?vue&type=template&id=33baaa26&scoped=true&"
import script from "./FtpRequests.vue?vue&type=script&lang=js&"
export * from "./FtpRequests.vue?vue&type=script&lang=js&"
import style0 from "./FtpRequests.vue?vue&type=style&index=0&id=33baaa26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33baaa26",
  null
  
)

export default component.exports